module.exports = __webpack_public_path__ + "media/images/icons/replay-icon-fe7c7de36ffd772f137e419016f719b3.svg";